const DRAFT_PREFIX = 'quote-service-draft:';

export function addOneCalendarYear(isoDate) {
  if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(isoDate)) return '';
  const [year, month, day] = isoDate.split('-').map(Number);
  const targetYear = year + 1;
  const lastDay = new Date(targetYear, month, 0).getDate();
  const clamped = Math.min(day, lastDay);
  return `${targetYear}-${String(month).padStart(2, '0')}-${String(clamped).padStart(2, '0')}`;
}

export function quoteDraftKey(userId, quoteId) {
  return `${DRAFT_PREFIX}${userId}:${quoteId || 'new'}`;
}

export function readQuoteServiceDraft(userId, quoteId) {
  if (!userId || typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(quoteDraftKey(userId, quoteId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || !parsed.serviceForm) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeQuoteServiceDraft(userId, quoteId, draft) {
  if (!userId || typeof sessionStorage === 'undefined' || !draft?.serviceForm) return;
  sessionStorage.setItem(quoteDraftKey(userId, quoteId), JSON.stringify(draft));
}

export function clearQuoteServiceDraft(userId, quoteId) {
  if (!userId || typeof sessionStorage === 'undefined') return;
  sessionStorage.removeItem(quoteDraftKey(userId, quoteId));
}

export function clearAllQuoteServiceDrafts() {
  if (typeof sessionStorage === 'undefined') return;
  const keys = [];
  for (let i = 0; i < sessionStorage.length; i += 1) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith(DRAFT_PREFIX)) keys.push(key);
  }
  keys.forEach((key) => sessionStorage.removeItem(key));
}
